<div class="ap-grid-row" [ngClass]="noGutter() ? 'ap-grid-row--no-gutter' : 'ap-grid-row--with-gutter'">
    <ng-content></ng-content>
</div>
